export enum DialogState {
  OPEN,
  CLOSE
}
export class ScrollBarData {

  private static ScrollbarWidth: number;

  private static getScrollbarWidth() {
    if(!ScrollBarData.ScrollbarWidth) {
      const outer = document.createElement("div");
      outer.style.visibility = "hidden";
      outer.style.width = "100px";
      outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
      document.body.appendChild(outer);
      let widthNoScroll = outer.offsetWidth;
      outer.style.overflow = "scroll";
      const inner = document.createElement("div");
      inner.style.width = "100%";
      outer.appendChild(inner);
      let widthWithScroll = inner.offsetWidth;
      outer.parentNode.removeChild(outer);
      ScrollBarData.ScrollbarWidth = widthNoScroll - widthWithScroll;
    }
    return ScrollBarData.ScrollbarWidth;
  }

  static updateBodyWidth(dialogState :DialogState, hasScrollbar = false) {
    if(dialogState === DialogState.OPEN && hasScrollbar) {
      document.getElementsByTagName("html")[0].style.marginRight = `${ScrollBarData.getScrollbarWidth()}px`;
    }else {//when closed pop up
      document.getElementsByTagName("html")[0].style.marginRight = '0px';
    }
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/components/shared/scroll-bar-data.ts